// extracted by mini-css-extract-plugin
module.exports = {"datepicker":"styles_datepicker__1Af3p","label":"styles_label__su-YF"};